import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { ChunkTools } from '@sol/components';

bootstrapApplication(AppComponent, appConfig)
  .then(() => {
    ChunkTools.clearReloadFlag();
  })
  .catch(err => console.error(err));
